import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TypeEntretien } from 'src/app/shared/models/typeEntretien';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TypeEntretienModalAjoutComponent } from '../modal/typeEntretien-modal-ajout/typeEntretien-modal-ajout.component';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { TypeEntretienModalDetailComponent } from '../modal/typeEntretien-modal-detail/typeEntretien-modal-detail.component';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-typeEntretien',
	templateUrl: './list-typeEntretien.component.html',
	styleUrls: ['./list-typeEntretien.component.scss']
})
export class ListTypeEntretienComponent implements OnInit {
	typeEntretien: TypeEntretien[] = [];
	currentPage = 1;
	itemsPerPage = 10;

	typeEntretienCsvFile: File = null;
	searchedSkill = '';
	searchedName = '';

	dismissible: true;
	alerts: any[] = [];

	nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	sortType = 'firstName';
	sortOrder: SortOrder = 'asc';

	searchedText: string;

	editTypeEntretienModalRef: BsModalRef;
	addTypeEntretienModalRef: BsModalRef;
	screenWidth: number;
	isMobile: boolean = false;

	isListingLoading: boolean = true;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		this.getTypeEntretien();
		this.isAddable = true;
	}

	getTypeEntretien(): void {
		this.isListingLoading = true;
		this.facade.typeEntretienService.getAllTypeEntretien().subscribe({
			next: (val) => {
				this.typeEntretien = val.filter((e) => e.name !== 'Sans');
				this.itemsPerPage = this.typeEntretien.length >= 8 ? 10 : 8;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
				this.typeEntretien = [];
			}
		});
	}

	selectTypeEntretien(typeEntretien: TypeEntretien): void {
		const link = ['/typeEntretien', typeEntretien.id];
		this.router.navigate(link);
	}

	importTypeEntretien(event: any): void {
		this.typeEntretienCsvFile = event.target.files[0];

		this.facade.typeEntretienService
			.importTypeEntretien(this.typeEntretienCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.alerts.push({
						type: 'success',
						msg: `${importStats.entitiesAdded} typeEntretien ont été ajoutés,
                  ${importStats.entitiesBeforeImport} étaient déjà présents.`
					});

					this.getTypeEntretien();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.error(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		this.addTypeEntretienModalRef = this.modalService.show(
			TypeEntretienModalAjoutComponent,
			{
				class: 'modal-lg',
				backdrop: 'static'
			}
		);

		this.addTypeEntretienModalRef.onHide.subscribe((reason: string | any) => {
			this.getTypeEntretien();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalEdit(typeEntretien: TypeEntretien) {
		const initialState = {
			typeEntretien: typeEntretien
		};
		this.editTypeEntretienModalRef = this.modalService.show(
			TypeEntretienModalDetailComponent,
			{
				class: '',
				initialState
			}
		);

		this.editTypeEntretienModalRef.onHide.subscribe((reason: string | any) => {
			this.getTypeEntretien();
		});
	}
}
